module.exports = __webpack_public_path__ + "img/creation-graphique.b34a75ff.png";